import React from "react";
import FTLErrorPage from "./FTLErrorPage";
export default class FTLErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setState({ hasError: false });
        }
    }
    render() {
        return (React.createElement(FTLErrorPage, { title: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430", message: React.createElement(React.Fragment, null,
                React.createElement("div", null, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435."),
                React.createElement("div", null, "\u041C\u044B \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u043B\u0438 \u043E\u0442\u0447\u0451\u0442 \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0435\u0433\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0430\u043C.")), buttons: ["refresh"], hasError: this.state.hasError, fullScreen: this.props.fullScreen }, this.props.children));
    }
}
//# sourceMappingURL=FTLErrorBoundary.js.map